export function callBackTempsFort() {
  "use strict";

  if ($(".carousel-tempsforts").length > 0) {
    var carouselSlideshow = tns({
      container: ".carousel-tempsforts",
      autoplay: false,
      loop: false,
      center: true,
      items: 1,
      fixedWidth: false,
      navContainer: "#customize-thumbnails",
      navAsThumbnails: true,
      mouseDrag: true,
      swipeAngle: false,
      controlsContainer: ".carousel-navigation",
      nextButton: "#carousel-navigation-next",
      prevButton: "#carousel-navigation-prev",
      responsive: {
        "575": {
          items: 2,
          fixedWidth: 1192,
        },

      },
    });

    //initialisation du script d"accessibilité
    var sliderA11Y = tinySliderA11Y({
      tns: carouselSlideshow,
      parent: ".carousel-slideshow-parent",
      parentLabelText: "Article à la une",
      slideLabel: ".list-article-title",
      navLabel: "Diapositive ",
      navCurrentLabel: "(Diapositive courante)",
    });
  }

}(jQuery);
